import React from "react";
import { Menu, Dropdown } from "antd";
import { useDispatch } from "react-redux";
// import { Container } from "reactstrap";
// import { useState } from "react";
import { GlobalOutlined } from "@ant-design/icons";
import { lang_change } from "../../Redux/actions";
// import { lang_change } from "../../redux/actions/index";
import TranslateIcon from "../../Assets/external_icons/translate.png"

const SelectLang = () => {
  // const { confirm } = Modal;
  // const lang_choiced = useSelector((state) => state.lang_change);

  const dispatch = useDispatch();

  const items = [
    {
      key: 1, 
      label: 'فارسی',
      onClick: () => {
        dispatch(lang_change(1));
        window.localStorage.setItem("lang", "persian")
        window.location.reload();
      },
      icon: <i className="flag-icon flag-icon-ir" />
    },
    {
      key: 2, 
      label: 'English',
      onClick: () => {
        dispatch(lang_change(2));
        window.localStorage.setItem("lang", "english")
        window.location.reload();
      },
      icon: <i className="flag-icon flag-icon-gb" />,
      // disabled:true
    },
    {
      key: 3, 
      label: 'العربیة',
      onClick: () => {
        // window.location.reload();
        // dispatch(lang_change(1));
        // window.localStorage.setItem("lang", "persian")
      },
      icon: <i className="flag-icon flag-icon-iq" />,
      disabled:true
    },
  ]

  return (
    <Dropdown.Button
      // style={{marginLeft:"20px",marginRight:"20px"}}
      className=" change-lang-dropdown"
      menu={{
        items,
      }}
      placement="bottomRight"
      icon={<img src={TranslateIcon} width={24}></img>}
      trigger={["click"]}
      type="link"
    ></Dropdown.Button>
  );
};
export default SelectLang;
